import { appConfig } from '@/configs/app.config';

export const logError = (...rest: any[]) => {
  if (appConfig.showLog) {
    console.error(...rest);
  }
};
